<template>
    <div>
        MessagePageView
    </div>
</template>

<script>

export default {
    name: "MessagePageView",
    props: ['bottomTab'],
    components: {
    },
    data() {
        return {
        }
    },
    methods: {

    }

}
</script>
  
<style scoped lang="less">

</style>